export class ValueMappingResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        },
        {
            "name": "color",
            "baseName": "color",
            "type": "HealthStatus",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValueMappingResult.attributeTypeMap;
    }
    constructor() {
    }
}
